define('models/pages/multi-account/accounts',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var Accounts = Model.extend({
        urlPath: '/api/multi-account/list',
        defaults: {
            items: [
                // {
                //     currencyCode: 'usd',
                //     balance: 0
                // }
            ]
        },
        urlParams: function() {
            return this.get('params').urlParams();
        },
        parse: function(data) {
            console.log('Accounts parse', data);
            return {
                items: data
            };
        }
    });

    return Accounts;
});
